import type { IconType } from '../../../../theme/themes/ThemeTypes';

export const EnergyFlow: IconType = ({ colour, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={46} height={47} fill="none" {...props}>
    <path
      stroke={colour}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M26.533 21.153 28.88 3.5 7.707 25.86h11.76L17.12 43.5l21.173-22.347h-11.76Z"
    />
  </svg>
);
